import { useNavigate } from '@tanstack/react-router';
import { useToast } from '@hana/ui';
import { COSTING_JOBS } from './costingJobs';
import { calcCosting } from './costing';
import { f1, norm } from './view';
import s from './jobsPad.module.css';

// Mint-Cost-iPad › tab Costing: thẻ 2 cột (job, cảnh báo, 4 số, trạng thái, hạn duyệt, nút chính). Chỉ đọc; nút ghi báo toast.

const STATUS = {
  draft: { k: 'Nháp', tone: 'gray' },
  pend: { k: 'Chờ duyệt', tone: 'warn' },
  appr: { k: 'Đã duyệt', tone: 'ok' },
  lockp: { k: 'Đã khoá kỳ', tone: 'violet' },
} as const;

export function JobsPad({ q }: { q: string }) {
  const toast = useToast();
  const nav = useNavigate();
  const nq = norm(q.trim());
  const rows = COSTING_JOBS.map(calcCosting).filter((c) => !nq || norm(`${c.job.no} ${c.job.cus}`).includes(nq));
  return (
    <div className={s.grid}>
      {rows.map((c) => {
        const j = c.job;
        const v = c.cost - c.qCost;
        const st = STATUS[j.s];
        const late = !!(c.deadline && c.deadline.lv);
        const kv: [string, string, string | undefined][] = [
          ['Mua dự kiến', f1(c.qCost), ''],
          ['Thực tế', f1(c.cost), ''],
          ['Chênh', (v > 0.04 ? '+' : '') + f1(v), v > 3 ? s.err : v > 0.04 ? s.warn : s.ok],
          ['GP QT', f1(c.gp), c.gp < 0 ? s.err : s.ok],
        ];
        return (
          <section key={j.no} className={s.card} title="Mở chi tiết costing" aria-label={`Costing ${j.no}`} onClick={() => void nav({ to: '/ezy/cost/$job', params: { job: j.no } })}>
            <div className={s.top}>
              <b className={s.no}>{j.no}</b>
              <span className={s.warns} title={c.W.map((w) => w.k).join(' · ') || 'Không có cảnh báo'}>
                {c.wr > 0 && (
                  <span className={`${s.chip} ${s.cErr}`}>
                    <i className={s.dErr} />
                    {c.wr}
                  </span>
                )}
                {c.wo > 0 && (
                  <span className={`${s.chip} ${s.cWarn}`}>
                    <i className={s.dWarn} />
                    {c.wo}
                  </span>
                )}
                {!c.W.length && <span className={s.dOk} aria-label="Không có cảnh báo" />}
              </span>
            </div>
            <div className={s.cus}>{j.cus}</div>
            <div className={s.kv}>
              {kv.map(([k, val, cls]) => (
                <div key={k}>
                  <span>{k}</span>
                  <b className={cls ?? ''}>{val}</b>
                </div>
              ))}
            </div>
            <div className={s.foot}>
              <span className={`${s.chip} ${s[`t_${st.tone}`]}`}>
                <i className={s[`d_${st.tone}`]} />
                {st.k}
              </span>
              {late && (
                <span className={`${s.chip} ${c.deadline!.lv === 'r' ? s.cErr : s.cWarn}`} title={c.deadline!.tip}>
                  <i className={c.deadline!.lv === 'r' ? s.dErr : s.dWarn} />
                  {c.deadline!.lv === 'r' ? `Trễ ${-c.deadline!.left} ngày` : `Sắp trễ · còn ${c.deadline!.left} ngày`}
                </span>
              )}
              {j.s !== 'lockp' && (
                <button
                  type="button"
                  className={s.act}
                  onClick={(e) => {
                    e.stopPropagation();
                    toast({ msg: 'Chưa mở ghi ở bản này' });
                  }}
                >
                  {c.priLabel}
                </button>
              )}
            </div>
          </section>
        );
      })}
    </div>
  );
}
